import { render } from "./CommandEvent.vue?vue&type=template&id=421bcf27"
import script from "./CommandEvent.vue?vue&type=script&lang=js"
export * from "./CommandEvent.vue?vue&type=script&lang=js"

import "./CommandEvent.vue?vue&type=style&index=0&id=421bcf27&lang=css"
script.render = render

export default script